import { render, staticRenderFns } from "./_Detail.vue?vue&type=template&id=2e3809dd&scoped=true&"
import script from "./_Detail.vue?vue&type=script&lang=js&"
export * from "./_Detail.vue?vue&type=script&lang=js&"
import style0 from "./_Detail.vue?vue&type=style&index=0&id=2e3809dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3809dd",
  null
  
)

export default component.exports